import { cn } from '@plato/ui/util/classes';

function Skeleton({ className, ...props }: React.HTMLAttributes<HTMLDivElement>): React.ReactElement {
    return <div className={cn('animate-pulse bg-neutral-100', className)} {...props} />;
}

export { Skeleton };
